let breakpoint;
let isRegistered = false;

// breakpoints below match Tailwind breakpoints
export const breakpoints = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  xl2: '2xl',
};

// Gets breakpoint from css. This rule is declared under shared/_global.scss
function _getBreakpoint() {
  try {
    const docRoot = document.querySelector('html');

    return window.getComputedStyle(docRoot, '::before')
      .getPropertyValue('content')
      .replace(/"/g, '') || breakpoints.lg; // Normalize between browsers
  } catch(err) {
    return breakpoints.lg; // Default if missing for some reason
  }
}

// Cache breakpoints
export function getCurrentBreakpoint() {
  if (breakpoint) {
    return breakpoint;
  }

  breakpoint = _getBreakpoint();

  if (!isRegistered) {
    // Reset breakpoint on resize
    window.addEventListener('resize', () => breakpoint = undefined);
    isRegistered = true;
  }

  return breakpoint;
}

export function isMobile() {
  return [breakpoints.xs, breakpoints.sm, breakpoints.md].includes(getCurrentBreakpoint());
}

export function isSmallMobile() {
  return [breakpoints.xs, breakpoints.sm].includes(getCurrentBreakpoint());
}
